// Module
var code = "<template> <div class=\"loading-overlay\" show.bind=\"loading\"></div> <div class=\"loading-dialog\" show.bind=\"loading || isLoading\"> <div class=\"loading-dialog-body\"> <div class=\"loading_modal\"> <i class=\"fa fa-heart heartbeat\"></i> <br/> <br/> <span class=\"title\">LOADING</span> </div> </div> </div> </template> ";
// Exports
export default code;